import {
  GET_CATALOG_ITEMS,
  GET_CATALOG_ITEMS_SUCCESS,
  GET_CATALOG_ITEMS_FAIL,
  ADD_CATALOG_ITEM,
  ADD_CATALOG_ITEM_SUCCESS,
  ADD_CATALOG_ITEM_FAIL,
  UPDATE_CATALOG_ITEM,
  UPDATE_CATALOG_ITEM_SUCCESS,
  UPDATE_CATALOG_ITEM_FAIL,
  DELETE_CATALOG_ITEM,
  DELETE_CATALOG_ITEM_SUCCESS,
  DELETE_CATALOG_ITEM_FAIL,
  SET_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  catalogItems: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const catalogReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATALOG_ITEMS:
      return { ...state, loading: true }
    case GET_CATALOG_ITEMS_SUCCESS:
      return { ...state, loading: false, catalogItems: action.payload }
    case GET_CATALOG_ITEMS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_CATALOG_ITEM:
      return { ...state, loading: true }
    case ADD_CATALOG_ITEM_SUCCESS:
      return { ...state, loading: false, status: "success", fieldErrors: {} } // Clear field errors on success
    case ADD_CATALOG_ITEM_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_CATALOG_ITEM:
      return { ...state, loading: true }
    case UPDATE_CATALOG_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        fieldErrors: {}, // Clear field errors on success
      }
    case UPDATE_CATALOG_ITEM_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_CATALOG_ITEM:
      return { ...state, loading: true }
    case DELETE_CATALOG_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_CATALOG_ITEM_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default catalogReducer
